import { Modal, Row, Col, Button } from "antd";
import "../../../PricingPage.css";

const CreditsSuccessModal = (props) => {
    const { successModal, setSuccessModal } = props;

    const handleClickDomainUrl = () => {
        setSuccessModal(false);
    };
    return (
        <Modal
            title={
                <Row>
                    <div className="d-flex justify-content-center w-100">
                        <span
                            className="d-flex justify-content-center actionIconsSprite successTickIcon"
                            style={{
                                width: 60,
                                height: 60,
                            }}
                        ></span>
                    </div>
                </Row>
            }
            centered
            width={425}
            onOk={() => {}}
            className="successPricingModel"
            closable={false}
            open={successModal}
            footer={null}
            zIndex={1009}
        >
            <>
                <div className="mt-4 mb-2">
                    <Row>
                        <div className="d-flex justify-content-center w-100">
                            <span className="hs-fs-16 hs-fw-bolder hs-color-BlackRussian">You're All Set!</span>
                        </div>
                    </Row>
                    <Row className="d-flex justify-content-center">
                        <Col className="d-flex justify-content-center ms-3">
                            <div className="hs-fs-14">
                                Your credits have been added to HelloSend and will appear in our system shortly.
                            </div>
                        </Col>
                    </Row>
                </div>

                <div className="d-flex justify-content-center justify-content-between">
                    <Button className="hs-w-100 goToServicePricingBtn" onClick={handleClickDomainUrl}>
                        Done
                    </Button>
                </div>
            </>
        </Modal>
    );
};

export default CreditsSuccessModal;
